import { defineComponent } from "vue";
import BaseModal from "../BaseModal/BaseModalComponent";
import { mapWritableState } from "pinia";
import { useRegisterTestStore } from "@/store/RegisterTestStore";

export default defineComponent({
  components: {
    BaseModal,
  },
  computed: {
    ...mapWritableState(useRegisterTestStore, ["patient"]),
  },
  methods: {
    toggleModal(status: boolean) {
      const el: any = this.$refs["base-modal"];
      el.toggleBaseModal(status);
    },
    goBack() {
      this.toggleModal(false);
    },
    goAhead() {
      this.$emit("nextStep");
      this.toggleModal(false);
    },
  },
});
